import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ShopCard from '../../../components/2025/ShopCard';
import styles from './styles.module.scss';
import { ShopData } from '../../../services/shopService';
import { client } from '../../../libs/client';
import { shop } from '../../../types/cms-types';
import { optimizeImage } from '../../../utils/imageOptimizer';

const ShopPreviewPage2025: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [shopData, setShopData] = useState<ShopData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const id = searchParams.get('id') || searchParams.get('contentId');
    const draftKey = searchParams.get('draftKey') || undefined;

    if (!id && !draftKey) {
      navigate('/2025/map', { replace: true });
      return;
    }

    if (!id) {
      setError('プレビューに必要なパラメータが不足しています（id）');
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const response = await client.get<shop<'get'>>({
          endpoint: 'shop',
          contentId: id,
          queries: draftKey ? { draftKey } : {},
        });

        if (!response) {
          setError('売店の取得に失敗しました');
          return;
        }

        // カテゴリーのマッピング
        const categoryMapping: { [key: string]: string } = {
          'ご飯 / 麺類': 'ご飯/麺類',
          揚げ物: '揚げ物',
          スイーツ: 'スイーツ',
          飲み物: '飲み物',
          その他: 'その他',
        };

        const firstCategory = response.shop_category[0] || 'その他';
        const mappedCategory = categoryMapping[firstCategory] || 'その他';

        const transformedShop: ShopData = {
          id: response.id,
          imageUrl: optimizeImage(response.shop_image.url, { width: 800, quality: 80 }),
          title: response.shop_name,
          shopMenuList: response.shop_menu_list.map((item) => ({
            menu: item.shop_menu,
            price: item.shop_menu_price,
          })),
          description: response.shop_detail || '',
          labels: response.shop_category,
          category: mappedCategory,
        };

        setShopData(transformedShop);
      } catch {
        setError('売店の取得でエラーが発生しました');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [searchParams, navigate]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return createPortal(
    <div className={styles.previewContainer}>
      {loading && (
        <div style={{ background: '#fff', padding: 24, borderRadius: 8 }}>読み込み中...</div>
      )}
      {!loading && error && (
        <div style={{ background: '#fff', padding: 24, borderRadius: 8, color: 'red' }}>
          {error}
        </div>
      )}
      {!loading && !error && shopData && (
        <div className={styles.previewCard}>
          <ShopCard sectionTitle="" shops={[shopData]} />
        </div>
      )}
    </div>,
    document.body,
  );
};

export default ShopPreviewPage2025;
